import { render, staticRenderFns } from "./VirtualController.vue?vue&type=template&id=f6b53ab6"
import script from "./VirtualController.vue?vue&type=script&lang=js"
export * from "./VirtualController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports